'use strict';/* global define:false */define('modules/feedback/services/feedback-process-sharing-settings/index',['angular'],function(ng){'use strict';/*

   ## Privacy Config
   GET /feedback-sharing-setting Read feedback-process sharing settings
   PUT /feedback-sharing-setting Configure feedback-process sharing settings

   */
model.$inject = ["$resource", "API_ENDPOINT"];var prefix='feedback-sharing-setting';// @ngInject
function model($resource,API_ENDPOINT){var url=API_ENDPOINT+prefix;// var shortCache = new AmnesiaCache( 1000 );
// var longCache  = new AmnesiaCache( 5000 );
var params={id:'@id'};var actions={config:{method:'GET'// cache  : longCache
},setConfig:{method:'PUT'}};return $resource(url+'/:id',params,actions);}return model;});
